module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"checkSites":"Check sites","jwtExpired":"Some sites jwt expired"}}')
  delete Component.options._Ctor
}
